// extracted by mini-css-extract-plugin
export default {"container":"duelana-tops_container__T4Wsm"};